import { createContext, useContext, useState } from "react";
import toast from "react-hot-toast";
import { api } from "../../api";
import { useAuth } from "../users";

export const GenresContext = createContext({});

function useGenres() {
  const context = useContext(GenresContext);

  if (!context) {
    throw new Error("useGenres must be used within a MoviesProvider");
  }

  return context;
}

const GenresProvider = ({ children }) => {
  const [genres, setGenres] = useState([]);
  const { bearer } = useAuth();

  const getGenres = async () => {
    await api
      .get("/genres", bearer)
      .then((res) => {
        setGenres(res.data);
      })
      .catch((err) => {
        toast.error(err.response.data.error);
      });
  };

  const registerGenres = async (genre) => {
    await api
      .post("/genres/register", genre, bearer)
      .then((res) => {
        toast.success("Gênero registrado com sucesso!");
      })
      .catch((err) => {
        toast.error(err.response.data.error);
      })
      .finally(() => getGenres());
  };

  return (
    <GenresContext.Provider
      value={{
        genres,
        getGenres,
        registerGenres,
      }}
    >
      {children}
    </GenresContext.Provider>
  );
};

export { GenresProvider, useGenres };
